import React from 'react';

export default class Steps extends React.Component {
    render() {
        const { steps = [], status } = this.props;
        if(!steps) return null;
        return (
            <>
                {
                    Array.isArray(steps)
                        ? steps.map(step => {
                            return <div className={status === 'current' ? 'current' : 'past'}>
                                    {step}
                                </div>
                            })
                        : <div className={status === 'current' ? 'current' : 'past'}>
                            {steps}
                        </div>
                }
            </>
        )
    }
}